import React, { useState } from 'react';
import { Box, Tab, CircularProgress, Typography } from '@mui/material';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Main from '../layouts/Main';
import { useApi } from '../contexts/Api';
import CategoryList from '../components/CategoryList';

const Categories = () => {
  const [value, setValue] = useState('1');
  const { categories, loadingCategories, fetchCategories } = useApi();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const languages = [
    { code: 'en', label: 'English' },
    { code: 'fin', label: 'Finnish' },
    { code: 'de', label: 'German' },
    { code: 'fr', label: 'French' }
  ];

  return (
    <Main>
      <div className="page-header">
        <div>
          <h1 className="page-title">Categories</h1>
        </div>
      </div>

      <div className="row">
        <div className="col-12">
          <div className="card custom-card">
            <div className="card-header">
              <div className="card-title">Product Categories</div>
            </div>
            <div className="card-body">
              {loadingCategories ? (
                <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
                  <CircularProgress />
                </Box>
              ) : (
                <TabContext value={value}>
                  <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <TabList onChange={handleChange}>
                      {languages.map((lang, index) => (
                        <Tab key={lang.code} label={lang.label} value={String(index + 1)} />
                      ))}
                    </TabList>
                  </Box>
                  {languages.map((lang, index) => (
                    <TabPanel key={lang.code} value={String(index + 1)}>
                      <CategoryList 
                        categories={categories} 
                        language={lang.code}
                        onCategoriesUpdate={fetchCategories}
                      />
                    </TabPanel>
                  ))}
                </TabContext>
              )}
            </div>
          </div>
        </div>
      </div>
    </Main>
  );
};

export default Categories;